import React, { forwardRef, Fragment } from 'react';
import PropTypes from 'prop-types';

import EmbeddedCrossSellOfferCon from '../../EmbeddedCrossSellOfferCon';

import LargeImageProduct from './product';

import { StyledLargeImageEmbeddedWidgetCon } from './skins';

const LargeImageLayout = forwardRef((props, ref) => {
  const {
    isMobile,
    displayProducts,
    selectedVariantInfo,
    carouselItemsToShow,
    theme,
    embeddedWidgetStyles,
    offerLevelQuantityAdded,
    offerLevelDiscountQuantity,
    isCarouselArrowsAlwaysVisible,
    ...restProps
  } = props;

  return (
    <StyledLargeImageEmbeddedWidgetCon
      ref={ref}
      {...embeddedWidgetStyles}
      className="mr-embedded-widget mr-embedded-widget--cross-sell mr-embedded-widget--large-image"
    >
      <EmbeddedCrossSellOfferCon
        isMobile={isMobile}
        renderInCarousel
        carouselItemsToShow={carouselItemsToShow}
        offerHeaderText={theme.offer_header_text}
        offerHeaderFontSize={
          isMobile ? theme.offerHeaderMobileFontSize : theme.offerHeaderFontSize
        }
        offerHeaderMobileFontSize={theme.offerHeaderMobileFontSize}
        offerHeaderFontStyle={theme.offerHeaderFontStyle}
        offerHeaderFontWeight={theme.offerHeaderFontWeight}
        offerHeaderTextColor={theme.offerHeaderTextColor}
        offerHeaderTextDecoration={theme.offerHeaderTextDecoration}
        offerHeaderFontFamily={theme.offerHeaderFontFamily}
        offerHeaderTextAlignment={theme.offerHeaderTextAlignment}
        offerHeaderPadding={
          isMobile ? theme.offerHeaderMobilePadding : theme.offerHeaderPadding
        }
        offerHeaderMargin={
          isMobile ? theme.offerHeaderMobileMargin : theme.offerHeaderMargin
        }
        offerHeaderMobilePadding={theme.offerHeaderMobilePadding}
        offerSubtitleText={theme.offerSubtitleText}
        offerSubtitleFontSize={
          isMobile
            ? theme.offerSubtitleMobileFontSize
            : theme.offerSubtitleFontSize
        }
        offerSubtitleMobileFontSize={theme.offerSubtitleMobileFontSize}
        offerSubtitleFontStyle={theme.offerSubtitleFontStyle}
        offerSubtitleFontWeight={theme.offerSubtitleFontWeight}
        offerSubtitleTextColor={theme.offerSubtitleTextColor}
        offerSubtitleTextDecoration={theme.offerSubtitleTextDecoration}
        offerSubtitleFontFamily={theme.offerSubtitleFontFamily}
        offerSubtitleTextAlignment={theme.offerSubtitleTextAlignment}
        offerSubtitlePadding={
          isMobile
            ? theme.offerSubtitleMobilePadding
            : theme.offerSubtitlePadding
        }
        offerSubtitleMargin={
          isMobile ? theme.offerSubtitleMobileMargin : theme.offerSubtitleMargin
        }
        productsContainerPadding={theme.productsContainerPadding}
        productsContainerMargin={theme.productsContainerMargin}
        carouselActionColor={
          theme.embeddedProductButtonStyle === 'text'
            ? theme.embeddedProductButtonTextColor
            : theme.productButtonColor
        }
        offerLevelQuantityAdded={offerLevelQuantityAdded}
        offerLevelDiscountQuantity={offerLevelDiscountQuantity}
        productButtonColor={theme.productButtonColor}
        productButtonStyle={theme.embeddedProductButtonStyle}
        productButtonTextColor={theme.embeddedProductButtonTextColor}
        countOfItemsInOffer={displayProducts.length}
        isCarouselArrowsAlwaysVisible={isCarouselArrowsAlwaysVisible}
        carousalStyleProps={{
          isEmbeddedCarouselEnabled: theme.isEmbeddedCarouselEnabled,
          desktopLayoutType: theme.desktopLayoutType,
          carouselArrowColor: theme.carouselArrowColor,
          carouselSliderColor: theme.carouselSliderColor,
        }}
      >
        {displayProducts.map((product, i) => (
          <Fragment key={`index-${i * 1}`}>
            <LargeImageProduct
              isMobile={isMobile}
              product={product}
              selectedVariant={selectedVariantInfo[product.originalIndex]}
              theme={theme}
              {...restProps}
            />
          </Fragment>
        ))}
      </EmbeddedCrossSellOfferCon>
    </StyledLargeImageEmbeddedWidgetCon>
  );
});

LargeImageLayout.propTypes = {
  isMobile: PropTypes.bool,
  displayProducts: PropTypes.array,
  selectedVariantInfo: PropTypes.array,
  carouselItemsToShow: PropTypes.number,
  theme: PropTypes.object,
  embeddedWidgetStyles: PropTypes.object,
  offerLevelQuantityAdded: PropTypes.bool,
  offerLevelDiscountQuantity: PropTypes.number,
  isCarouselArrowsAlwaysVisible: PropTypes.bool,
};

export default LargeImageLayout;
